<template>
  <div>
    <svg
      t="1508738709248"
      class="screenfull-svg"
      viewBox="0 0 128 128"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2069"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="128px"
      height="128px"
      @click="click"
    >
      <g id="图层_1_1_">
        <path
          fill="#409EFF"
          d="M97.256,118.745c-1.945,1.101-4.418,0.249-5.425-1.771c-0.493-1.002-0.601-2.149-0.293-3.242
		c0.312-1.094,1.004-1.998,1.955-2.535c16.351-9.34,26.512-27.413,26.512-47.183c0-19.776-10.161-37.856-26.517-47.187
		c-0.946-0.541-1.639-1.442-1.95-2.544c-0.308-1.082-0.2-2.233,0.286-3.229c0.701-1.408,2.064-2.283,3.552-2.283
		c0.651,0,1.302,0.174,1.88,0.507C116.221,20.091,128,41.063,128,64.011C128.001,86.95,116.221,107.923,97.256,118.745z"
        />
        <path
          fill="#409EFF"
          d="M103.041,82.98c-3.2,5.539-7.716,10.004-13.068,12.91c-1.968,1.068-4.422,0.178-5.391-1.894
		c-0.479-1.001-0.563-2.147-0.245-3.218c0.331-1.098,1.037-1.994,1.999-2.52c8.462-4.588,13.717-13.884,13.717-24.251
		c0-10.368-5.257-19.657-13.72-24.259c-0.959-0.523-1.671-1.415-1.998-2.509c-0.321-1.074-0.237-2.224,0.239-3.232
		c0.688-1.454,2.058-2.357,3.587-2.357c0.629,0,1.235,0.157,1.801,0.463c5.353,2.912,9.872,7.378,13.079,12.914
		c3.275,5.665,5.008,12.227,5.008,18.977C108.049,70.751,106.316,77.313,103.041,82.98z"
        />
      </g>
      <g id="图层_2">
        <g>
          <path
            fill="#2F3133"
            d="M72.012,128.04c-1.394,0.673-3.156,0.396-4.324-0.729l-0.182-0.17c-2.594-2.449-7.77-7.283-13.35-12.162
			c-12.286-10.758-16.168-12.699-17.278-13.088c-2.049-0.184-3.658-2.055-3.658-4.259c0-2.354,1.793-4.28,3.998-4.28
			c2.307,0,6.03,1.102,21.105,14.209c2.313,2.016,4.569,4.035,6.603,5.871l1.434,1.31V13.046l-1.402,1.153
			c-2.52,2.065-5.423,4.422-8.407,6.759C40.03,33.951,36.242,35.041,33.99,35.041H12.204c-2.669,0-4.201,2.235-4.201,6.127v46.059
			c0,3.381,2.545,6.125,5.672,6.125h6.023c2.208,0,4.004,1.926,4.004,4.281c0,2.359-1.795,4.279-4.004,4.279h-6.023
			C6.129,101.912,0,95.323,0,87.227V41.171c0-3.921,1.022-7.379,2.958-10c2.21-3.021,5.498-4.688,9.245-4.688H33.67l0.268-0.044
			c0.951-0.335,5.113-2.272,18.79-13.092C60.504,7.194,67.752,1.032,67.861,0.923c1.191-1.007,2.882-1.21,4.254-0.509
			c1.387,0.718,2.25,2.194,2.25,3.855v119.855C74.365,125.807,73.443,127.346,72.012,128.04z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Screenfull',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data() {
    return {
      isFullscreen: false
    }
  },
  methods: {
    click() {
      console.log('do nothing')
      /*
         if (!screenfull.enabled) {
         this.$message({
         message: 'you browser can not work',
         type: 'warning'
         })
         return false
         }
         screenfull.toggle()
         */
    }
  }
}
</script>

<style scoped>
  .screenfull-svg {
    display: inline-block;
    cursor: pointer;
    fill: #35628a;
    width: 20px;
    height: 20px;
    vertical-align: 10px;
  }
</style>
